const translations = {
  "en": {
    "and": "and",
    "By continuing, you agree to the": "By continuing, you agree to the",
    "Continue with Apple": "Continue with Apple",
    "Continue with Google": "Continue with Google",
    "Get Started": "Get Started",
    "Other options": "Other options",
    "Privacy Policy": "Privacy Policy",
    "ranking pack": "ranking pack",
    "Terms of Use": "Terms of Use"
  },
  "zh-tw": {
    "and": "和",
    "By continuing, you agree to the": "繼續即表示你同意",
    "Continue with Apple": "透過 Apple 繼續",
    "Continue with Google": "透過 Google 繼續",
    "Get Started": "開始",
    "Other options": "其他選項",
    "Privacy Policy": "隱私權政策",
    "ranking pack": "排名資料包",
    "Terms of Use": "使用條款"
  }
};

export default translations;
